import { useEffect, useState } from 'react';
import { getAllEncounter, getOneEncounter } from 'utils/EncounterAPI';
import { Encounter } from 'types/Encounter';

export default function useEncounter(id?: string) {
  const [encounters, setEncounters] = useState<Encounter[]>([]);
  const [encounter, setEncounter] = useState<Encounter>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Not a huge fan of variables that appear/dissapear based on call type
    // but no time to rewrite
    if (!id) {
      const fetchData = async () => {
        const allEncounter = await getAllEncounter();
        setEncounters(allEncounter);
        setIsLoading(false);
      };

      fetchData();
    } else {
      const fetchData = async () => {
        const oneEncounter = await getOneEncounter(id!);
        setEncounter(oneEncounter);
        setIsLoading(false);
      };

      fetchData();
    }
  }, [id]);

  return {
    encounters,
    encounter,
    isLoading,
  };
}
